import { defaults } from 'lodash'

export const initialImagesState = {
  currentImage: null,
  items: [],
}

export default defaults({}, initialImagesState)
